import React, { useState } from 'react'
import { Link } from '@inertiajs/react'
import { ChevronDown } from 'lucide-react'

type SettingsPage = 'profile' | 'password' | 'data-attributes' | 'business-hours' | 'macros' | 'agents' | 'teams' | 'security' | 'whatsapp' | 'widget' | 'api'

interface SettingsNavProps {
  activePage: SettingsPage
  isAdmin?: boolean
}

const ACCOUNT_ITEMS: { href: string; label: string; page: SettingsPage }[] = [
  { href: '/settings/profile', label: 'Perfil', page: 'profile' },
  { href: '/settings/password', label: 'Senha', page: 'password' },
]

const OTHER_ITEMS: { href: string; label: string; page: SettingsPage; adminOnly?: boolean }[] = [
  { href: '/settings/data-attributes', label: 'Atributos de Dados', page: 'data-attributes', adminOnly: true },
  { href: '/settings/business-hours', label: 'Horário de Funcionamento', page: 'business-hours', adminOnly: true },
  { href: '/settings/teams', label: 'Equipes', page: 'teams', adminOnly: true },
  { href: '/settings/security', label: 'Segurança', page: 'security', adminOnly: true },
  { href: '/macros', label: 'Macros', page: 'macros' },
  { href: '/settings/whatsapp', label: 'WhatsApp', page: 'whatsapp' },
  { href: '/settings/widget', label: 'Widget', page: 'widget', adminOnly: true },
  { href: '/settings/api', label: 'API', page: 'api', adminOnly: true },
]

export default function SettingsNav({ activePage, isAdmin = false }: SettingsNavProps): React.ReactElement {
  const isAccountActive = ACCOUNT_ITEMS.some((item) => item.page === activePage)
  const [isAccountOpen, setIsAccountOpen] = useState(isAccountActive)

  return (
    <nav className="w-48 border-r border-gray-200 bg-white p-3 space-y-0.5">
      {/* Other settings */}
      {OTHER_ITEMS.filter((item) => !item.adminOnly || isAdmin).map((item) => {
        const isActive = item.page === activePage
        return (
          <Link
            key={item.page}
            href={item.href}
            className={`block px-3 py-2 text-sm font-medium rounded-lg ${
              isActive
                ? 'bg-gray-100 text-gray-900'
                : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
            }`}
          >
            {item.label}
          </Link>
        )
      })}

      {/* Equipe - only for admins */}
      {isAdmin && (
        <Link
          href="/agents"
          className={`block px-3 py-2 text-sm font-medium rounded-lg ${
            activePage === 'agents'
              ? 'bg-gray-100 text-gray-900'
              : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
          }`}
        >
          Equipe
        </Link>
      )}

      {/* Account section with dropdown */}
      <div>
        <button
          onClick={() => setIsAccountOpen(!isAccountOpen)}
          className={`w-full flex items-center justify-between px-3 py-2 text-sm font-medium rounded-lg cursor-pointer ${
            isAccountActive
              ? 'bg-gray-100 text-gray-900'
              : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
          }`}
        >
          <span>Conta</span>
          <ChevronDown
            className={`w-4 h-4 transition-transform duration-200 ${
              isAccountOpen ? 'rotate-180' : ''
            }`}
          />
        </button>
        {isAccountOpen && (
          <div className="mt-0.5 ml-3 space-y-0.5">
            {ACCOUNT_ITEMS.map((item) => {
              const isActive = item.page === activePage
              return (
                <Link
                  key={item.page}
                  href={item.href}
                  className={`block px-3 py-2 text-sm font-medium rounded-lg ${
                    isActive
                      ? 'bg-gray-100 text-gray-900'
                      : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                  }`}
                >
                  {item.label}
                </Link>
              )
            })}
          </div>
        )}
      </div>
    </nav>
  )
}
